import { render, staticRenderFns } from "./DescriptionWrap.vue?vue&type=template&id=79ce74a6"
import script from "./DescriptionWrap.vue?vue&type=script&lang=js"
export * from "./DescriptionWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports